import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './page-number-notification.module.scss';
import {useAppSelector} from '@/hooks';

interface PageNumberNotificationProps {
  className?: string;
  pageId: string;
}
export function PageNumberNotification({className = '', ...props}: PageNumberNotificationProps): ReactElement<any> | null {
  const pageOrder = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages.pageOrder ?? [];
  });

  if (!pageOrder || !pageOrder.length) {
    return null;
  }

  const getPageNumber = (): ReactElement<any> => {
    return <Text className="content-body-white" val={(pageOrder.indexOf(props.pageId) + 1).toString()} bold size={TextSize.XXSMALL} />;
  };

  return <div className={`${styles.container} ${className} radius-round flex-center`}>{getPageNumber()}</div>;
}
